var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "completeSection", class: { isPc: !_vm.isSp } },
    [
      _c("TitleText", { attrs: { text: "会員登録完了" } }),
      _vm._v(" "),
      _vm.prevPageType.isOrganic()
        ? _c(
            "TextGeneral",
            { staticClass: "text" },
            [
              _vm._v("\n    ご登録ありがとうございます。"),
              _c("br"),
              _vm._v(
                "ご登録いただいた情報はプロフィールからいつでも変更・確認が可能です。\n    "
              ),
              _vm.prevPageType.isCompare() || _vm.prevPageType.isCompareList()
                ? [
                    _vm.isSp
                      ? _c("CompareOfferSp", {
                          attrs: { "compare-link": _vm.nextPageUrl },
                          on: { "click-go-compare": _vm.onClickGoCompare },
                        })
                      : _c("CompareOfferPc", {
                          attrs: { "compare-link": _vm.nextPageUrl },
                          on: { "click-go-compare": _vm.onClickGoCompare },
                        }),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _c(
            "TextGeneral",
            { staticClass: "text" },
            [
              _vm._v("\n    会員登録が完了いたしました。"),
              _c("br"),
              _vm._v(" "),
              _vm.prevPageType.isShiryo()
                ? [_vm._v("引き続き資料請求の手続きをおこなってください。")]
                : _vm.prevPageType.isOc()
                ? [_vm._v("引き続きオープンキャンパス予約を進めてください。")]
                : _vm._e(),
            ],
            2
          ),
      _vm._v(" "),
      _vm.prevPageType.isReturnPage()
        ? _c("ButtonLink", {
            staticClass: "gotoTopButton",
            attrs: {
              "button-url": _vm.returnPageUrl,
              "button-text": "見ていたページに戻る",
              "button-color": "colorPrimaryBorder",
              "button-size": "sizeLarge",
            },
            on: { "button-clicked": _vm.onClickReturnPage },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.prevPageType.isCompare() ||
      _vm.prevPageType.isCompareList() ||
      _vm.prevPageType.isReturnPage()
        ? _c("ButtonLink", {
            staticClass: "gotoTopButton",
            attrs: {
              "button-url": _vm.isSp ? "/smp/" : "/",
              "button-text": "スタディサプリ進路トップへ",
              "button-color": _vm.BUTTON_COLOR_LIST.SAPURI_WHITE,
              "button-size": "sizeMedium",
            },
            on: { "button-clicked": _vm.onClickGoTop },
          })
        : _vm.prevPageType.isOrganic()
        ? _c("ButtonLink", {
            staticClass: "gotoTopButton",
            attrs: {
              "button-url": _vm.prevPageType.getUrlAfterCheckPrevPage(_vm.isSp),
              "button-text": "スタディサプリ進路トップへ",
              "button-color": "colorPrimary",
              "button-size": "sizeLarge",
            },
            on: { "button-clicked": _vm.onClickGoTop },
          })
        : _vm.prevPageType.isShiryo() || _vm.prevPageType.isOc()
        ? _c("ButtonLink", {
            staticClass: "gotoNextButton",
            attrs: {
              "button-url": _vm.prevPageType.getUrlAfterCheckPrevPage(_vm.isSp),
              "button-text": "次へ進む",
              "button-color": "colorPrimary",
              "button-size": "sizeLarge",
            },
            on: { "button-clicked": _vm.onClickGoNext },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.prevPageType.isOrganic()
        ? _c("ButtonLink", {
            staticClass: "gotoProfileButton",
            attrs: {
              "button-url": "/" + _vm.urlPrefix + "/quipMember/account/myPage/",
              "button-text": "プロフィールへ",
              "button-color": _vm.BUTTON_COLOR_LIST.SAPURI_WHITE,
              "button-size": "sizeMedium",
            },
            on: { "button-clicked": _vm.onClickGoProfile },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }